import request from '@/lib/request'

/**
 * 用户补充信息 - Mock 接口
 * 后端真实接口接入后替换 mock 实现即可。
 */

// 模拟网络延迟
const sleep = (ms = 600) => new Promise(resolve => setTimeout(resolve, ms))

// 文档类型 code
export const DOC_TYPE = {
  FAMILY_CARD: 'FAMILY_CARD',
  SOCIAL_MEDIA: 'SOCIAL_MEDIA',
  BANK_STATEMENT: 'BANK_STATEMENT',
  PAYSLIP: 'PAYSLIP',
  DRIVER_LICENSE_FRONT: 'DRIVER_LICENSE_FRONT',
  DRIVER_LICENSE_BACK: 'DRIVER_LICENSE_BACK',
  BPJS_TK_FRONT: 'BPJS_TK_FRONT',
  BPJS_TK_BACK: 'BPJS_TK_BACK',
}

export const SupplementStatus = {
  UNSUBMIT: "UNSUBMIT",
  RESUBMIT: "RESUBMIT",
  SUBMITTED: "SUBMITTED",
  APPROVED: "APPROVED",
}

export let GetUploadUrlRequest = {
  type: '',
  fileName: ''
}

export let SubmitSupplementRequest = {
  items: []
}

export let SubmitSupplementItem = {
  type: '',
  ossKey: '',
}

/**
 * 查询用户补充信息（已上传的文档、协议状态等）
 * @returns {Promise<{code:number,data:object}>}
 */
export async function queryAdditionalInfo(config = {}) {
  // return {
  //   code: 'Success',
  //   msg: 'success',
  //   data: {
  //     // 是否已同意条款
  //     termsAgreed: false,
  //     // 文档列表
  //     documents: [
  //       {
  //         type: DOC_TYPE.FAMILY_CARD,
  //         uploaded: true,
  //         ossKey: '',
  //         status: "UNSUBMIT",
  //       },
  //       {
  //         type: DOC_TYPE.SOCIAL_MEDIA,
  //         uploaded: false,
  //         ossKey: '',
  //         status: "UNSUBMIT",
  //       },
  //       {
  //         type: DOC_TYPE.BANK_STATEMENT,
  //         uploaded: false,
  //         ossKey: '',
  //         status: "UNSUBMIT",
  //       },
  //       {
  //         type: DOC_TYPE.PAYSLIP,
  //         uploaded: false,
  //         ossKey: '',
  //         status: "UNSUBMIT",
  //       },
  //       {
  //         type: DOC_TYPE.DRIVER_LICENSE_FRONT,
  //         uploaded: false,
  //         ossKey: '',
  //         status: "UNSUBMIT",
  //       },
  //       {
  //         type: DOC_TYPE.DRIVER_LICENSE_BACK,
  //         uploaded: false,
  //         ossKey: '',
  //         status: "UNSUBMIT",
  //       }
  //     ]
  //   }
  // }
  return request.get('/api/v1/rental/member/supplement/status', {}, config)
}

/**
 * 上传单个文档
 * @param {{docType:string, file:File}} params
 */
export async function uploadDocument(params = {}) {
  await sleep(900)
  // 这里只是 mock，真实场景可使用 FormData 上传
  return {
    code: 200,
    msg: 'success',
    data: {
      docType: params.docType,
      fileUrl: `https://example.com/mock/${params.docType}-${Date.now()}.jpg`,
      fileName: (params.file && params.file.name) || `${params.docType}.jpg`
    }
  }
  // 真实接口示例：
  // const formData = new FormData()
  // formData.append('docType', params.docType)
  // formData.append('file', params.file)
  // return request.post('/api/v1/rental/additional-info/upload', formData, {
  //   headers: { 'Content-Type': 'multipart/form-data' }
  // })
}

/**
 * 提交补充信息
 * @param {{termsAgreed:boolean, documents:Array}} params
 */
export async function submitAdditionalInfo(params = {}) {
  return request.post('/api/v1/rental/member/supplement', params)
}

/**
 * 获取数据采集条款（详情/全文）
 */
export async function getDataCollectionTerms() {
  await sleep(300)
  return {
    code: 200,
    msg: 'success',
    data: {
      title: 'Data Collection Terms',
      contentHtml:
        '<h3>Data Collection Terms</h3>' +
        '<p>By checking the box below, you agree to provide your personal and document information for identity verification and order processing. Your information will be handled securely and used only for the purpose of evaluating your rent-to-own application.</p>' +
        '<p>Full terms content goes here ...</p>'
    }
  }
  // 真实接口：return request.get('/api/v1/rental/common/agreements', { sceneCode: 'DATA_COLLECTION' })
}

/***
 * 获取上传链接
 * @param params
 * @returns {Promise | Promise<unknown>}
 * @private
 */
export function getUploadUrl(params = GetUploadUrlRequest) {
  return request.post(`/api/v1/rental/member/supplement/upload-url`, params);
}
